// extracted by mini-css-extract-plugin
export var adminLinkTag = "_6-1q";
export var assigneePill = "_6-2m";
export var assigneesList = "_6-2l";
export var automationCard = "_6-50";
export var automationDetails = "_6-52";
export var automationLabel = "_6-54";
export var automationList = "_6-4z";
export var automationNotConfigured = "_6-56";
export var automationRow = "_6-53";
export var automationTitle = "_6-51";
export var automationValue = "_6-55";
export var backButton = "_6-1n";
export var cancelButton = "_6-24";
export var cardLabel = "_6-4h";
export var cardValue = "_6-4i";
export var configActions = "_6-6s";
export var configAssignee = "_6-5t";
export var configAssigneeDept = "_6-5v";
export var configAssigneeName = "_6-5u";
export var configAssignees = "_6-5s";
export var configContent = "_6-5f";
export var configDeactivateButton = "_6-6t";
export var configDeleteButton = "_6-6u";
export var configEmpty = "_6-5e";
export var configHeader = "_6-5g";
export var configLabel = "_6-5l";
export var configLabelWithIcon = "_6-5m";
export var configLoading = "_6-5d";
export var configNotes = "_6-5w";
export var configRow = "_6-5k";
export var configSection = "_6-5i";
export var configSectionTitle = "_6-5j";
export var configStatusCard = "_6-5p";
export var configStatusRow = "_6-5o";
export var configStep = "_6-5y";
export var configStepCount = "_6-61";
export var configStepHeader = "_6-5z";
export var configStepName = "_6-60";
export var configStepSkipped = "_6-65";
export var configStepSkippedBadge = "_6-66";
export var configStepsList = "_6-5x";
export var configSubstep = "_6-63";
export var configSubstepSkipped = "_6-64";
export var configSubsteps = "_6-62";
export var configValue = "_6-5n";
export var confirmButton = "_6-25";
export var contentGrid = "_6-37";
export var contentLoading = "_6-1j";
export var coverageDetails = "_6-4k";
export var coverageSection = "_6-4j";
export var dealSizeField = "_6-2g";
export var dealSizeInput = "_6-2f";
export var dealSizeSaveButton = "_6-2h";
export var deleteModal = "_6-6v";
export var detailPanelsContainer = "_6-2j";
export var detailsGrid = "_6-i";
export var dollarSign = "_6-2e";
export var editButton = "_6-2i";
export var editConfigButton = "_6-5h";
export var emptyState = "_6-j";
export var emptyStateText = "_6-l";
export var emptyStateTitle = "_6-k";
export var emptyText = "_6-4d";
export var errorContainer = "_6-1i";
export var expandButton = "_6-3e";
export var gridCard = "_6-4g";
export var headerActions = "_6-1v";
export var headerTags = "_6-1p";
export var hubspotLink = "_6-5q";
export var hubspotLinkTag = "_6-1t";
export var hubspotLinkText = "_6-5r";
export var infoCard = "_6-4c";
export var kpiDivider = "_6-2d";
export var kpiItem = "_6-29";
export var kpiLabel = "_6-2a";
export var kpiRow = "_6-27";
export var kpiSpacer = "_6-28";
export var kpiValue = "_6-2c";
export var kpiValueContainer = "_6-2b";
export var leftColumn = "_6-38";
export var loadMoreButton = "_6-36";
export var loadMoreContainer = "_6-35";
export var loadingContainer = "_6-1h";
export var loadingIcon = "_6-1k";
export var loadingIconSmall = "_6-5c";
export var metaSection = "_6-1m";
export var notStartedTag = "_6-1r";
export var notePill = "_6-47";
export var notePillHeader = "_6-48";
export var notePillStep = "_6-49";
export var notePillText = "_6-4b";
export var notePillTimestamp = "_6-4a";
export var notesGrid = "_6-46";
export var oeConfigLabel = "_6-69";
export var oeConfigRow = "_6-68";
export var oeConfigValue = "_6-6a";
export var oeEditWindowGroup = "_6-67";
export var oePlatformsList = "_6-6n";
export var oeProgressBadge = "_6-6o";
export var oeStepItem = "_6-6q";
export var oeStepItemCompleted = "_6-6r";
export var oeStepsList = "_6-6p";
export var oeSubOption = "_6-6j";
export var oeSubOptionActive = "_6-6k";
export var oeSubOptionDot = "_6-6m";
export var oeSubOptionIcon = "_6-6l";
export var oeSubOptions = "_6-6i";
export var oeToolDuration = "_6-6g";
export var oeToolHeader = "_6-6e";
export var oeToolItem = "_6-6c";
export var oeToolItemEnabled = "_6-6d";
export var oeToolName = "_6-6f";
export var oeToolToggle = "_6-6h";
export var oeToolsList = "_6-6b";
export var pageContainer = "_6-1g";
export var pageTitle = "_6-1o";
export var pageWrapper = "_6-0";
export var paymentCard = "_6-4q";
export var paymentLabel = "_6-4s";
export var paymentRow = "_6-4r";
export var paymentValue = "_6-4t";
export var portalCard = "_6-4u";
export var portalLabel = "_6-4w";
export var portalLogo = "_6-4y";
export var portalRow = "_6-4v";
export var portalValue = "_6-4x";
export var preInstallBadge = "_6-1s";
export var productNavBar = "_6-3";
export var productStatusDot = "_6-6";
export var productStatusDotComplete = "_6-7";
export var productStatusDotHelpRequested = "_6-b";
export var productStatusDotInProgress = "_6-8";
export var productStatusDotNotStarted = "_6-a";
export var productStatusDotReopened = "_6-9";
export var productTab = "_6-4";
export var productTabActive = "_6-5";
export var progressBar = "_6-3l";
export var progressBarFill = "_6-3m";
export var progressCard = "_6-3f";
export var progressCircle = "_6-o";
export var progressCircleBg = "_6-p";
export var progressCircleFill = "_6-q";
export var progressCircleText = "_6-r";
export var progressLabel = "_6-3h";
export var progressMeta = "_6-3g";
export var progressPercent = "_6-3n";
export var progressStats = "_6-3i";
export var progressSubvalue = "_6-3k";
export var progressSummary = "_6-m";
export var progressSummaryDetail = "_6-v";
export var progressSummaryInfo = "_6-s";
export var progressSummaryMain = "_6-n";
export var progressSummarySubtitle = "_6-u";
export var progressSummaryTitle = "_6-t";
export var progressValue = "_6-3j";
export var pushActions = "_6-20";
export var pushButton = "_6-1x";
export var pushButtonContainer = "_6-1w";
export var pushButtonSuccess = "_6-1z";
export var pushDateInfo = "_6-2p";
export var pushDateText = "_6-1y";
export var pushToggle = "_6-22";
export var pushTogglesContainer = "_6-21";
export var pushWarning = "_6-2n";
export var pushWarningPill = "_6-2o";
export var replayLinkTag = "_6-1u";
export var returnFlowCard = "_6-57";
export var returnFlowStat = "_6-59";
export var returnFlowStatLabel = "_6-5a";
export var returnFlowStatValue = "_6-5b";
export var returnFlowSummary = "_6-58";
export var rightColumn = "_6-39";
export var section = "_6-3a";
export var sectionCheckbox = "_6-3d";
export var sectionHeader = "_6-3b";
export var sectionTitle = "_6-3c";
export var selectAllButton = "_6-23";
export var sessionBadge = "_6-26";
export var sessionButton = "_6-34";
export var sessionDate = "_6-2z";
export var sessionInfo = "_6-2x";
export var sessionItem = "_6-2v";
export var sessionItemActive = "_6-2w";
export var sessionMeta = "_6-30";
export var sessionMetaItem = "_6-31";
export var sessionMetaLabel = "_6-32";
export var sessionMetaValue = "_6-33";
export var sessionTitle = "_6-2y";
export var sessionsButton = "_6-2k";
export var sessionsContainer = "_6-2q";
export var sessionsEmpty = "_6-2t";
export var sessionsHeader = "_6-2r";
export var sessionsList = "_6-2u";
export var sessionsLoading = "_6-2s";
export var spin = "_6-1l";
export var stepCard = "_6-x";
export var stepCardCircle = "_6-12";
export var stepCardCircleComplete = "_6-14";
export var stepCardCirclePartial = "_6-13";
export var stepCardComplete = "_6-y";
export var stepCardCount = "_6-16";
export var stepCardHeader = "_6-10";
export var stepCardPartial = "_6-z";
export var stepCardStatus = "_6-11";
export var stepCardSubsteps = "_6-17";
export var stepCardTitle = "_6-15";
export var stepDuration = "_6-3v";
export var stepHeader = "_6-3t";
export var stepItem = "_6-3p";
export var stepItemCompleted = "_6-3q";
export var stepItemExpanded = "_6-3s";
export var stepItemPartial = "_6-3r";
export var stepName = "_6-3u";
export var stepToggle = "_6-3w";
export var stepToggleOpen = "_6-3y";
export var stepTogglePlaceholder = "_6-3x";
export var stepsGrid = "_6-w";
export var stepsList = "_6-3o";
export var substepBullet = "_6-44";
export var substepCompleted = "_6-41";
export var substepDuration = "_6-45";
export var substepIcon = "_6-43";
export var substepItem = "_6-40";
export var substepName = "_6-42";
export var substepRow = "_6-18";
export var substepRowComplete = "_6-19";
export var substepRowDot = "_6-1b";
export var substepRowIcon = "_6-1a";
export var substepRowName = "_6-1c";
export var substepRowTime = "_6-1d";
export var substepsList = "_6-3z";
export var tab = "_6-f";
export var tabActive = "_6-g";
export var tabBar = "_6-e";
export var tabBarContainer = "_6-c";
export var tabBarContent = "_6-d";
export var tabContent = "_6-h";
export var tag = "_6-4o";
export var tagEmpty = "_6-4p";
export var tagLabel = "_6-4m";
export var tagList = "_6-4n";
export var tagSection = "_6-4l";
export var threeColGrid = "_6-4f";
export var topHeader = "_6-1";
export var topHeaderContent = "_6-2";
export var topHeaderLeft = "_6-1f";
export var topHeaderMain = "_6-1e";
export var twoColGrid = "_6-4e";